/*
 * @Descripttion:
 * @version:
 * @Author: wanglikun
 * @Date: 2022-06-01 08:28:56
 * @LastEditors: hongye
 * @LastEditTime: 2025-09-08 09:27:50
 */
import request from '../request'
const { VITE_APP_API_i18n_URL } = import.meta.env
const GET_I18N = VITE_APP_API_i18n_URL + 'i18n/i18n/sysInternational/getSysInternationalList'

export default class dictService {
  /**
   * 获取i18n数据
   * @param data
   * @returns
   */
  static getI18n(data: any): Promise<any> {
    return request.get(GET_I18N, data)
  }
}
